const weekdaysShort = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
const months = [
	'Январь',
	'Февраль',
	'Март',
	'Апрель',
	'Май',
	'Июнь',
	'Июль',
	'Август',
	'Сентябрь',
	'Октябрь',
	'Ноябрь',
	'Декабрь'
];
const weekdaysLong = [
	'Воскресенье',
	'Понедельник',
	'Вторник',
	'Среда',
	'Четверг',
	'Пятница',
	'Суббота'
];
const firstDayOfWeek = 1;
const labels = { nextMonth: 'следующий месяц', previousMonth: 'предыдущий месяц' }

export default {
	months,
	weekdaysLong,
	weekdaysShort,
	firstDayOfWeek,
	labels,
	locale: 'ru'
}


// WEBPACK FOOTER //
// ./components/Datepicker/Localization.ru.js